import Banner from "../../../assets/img/projects/LosPistoleros/Los_Pistoleros-Banner.png";

function App() {
  return (
    <div className="LP-banner">
      <img src={Banner} alt="Banner" />
    </div>
  );
}

export default App;
